// JsFromRoutes CacheKey 50b7699dc348dad65a2fe24fe62a09b3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  list: definePathHelper('get', '/template_packs/select'),
}
